import { render, staticRenderFns } from "./LTeacher.vue?vue&type=template&id=268f4c12&scoped=true&"
import script from "./LTeacher.vue?vue&type=script&lang=js&"
export * from "./LTeacher.vue?vue&type=script&lang=js&"
import style0 from "./LTeacher.vue?vue&type=style&index=0&id=268f4c12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f4c12",
  null
  
)

export default component.exports